// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateComment-cls1_KNp","cls2":"CreateComment-cls2_NRX CreateComment-cls1_KNp"};